import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { InterestInputField } from 'components/form';
import { ListingForm } from 'components/shared/TableListing';

import { StagesFormValues } from '../../../../types';

interface Props {
  isEdit: boolean;
  rowIndex: number;
  disabled?: boolean;
}

export const WinProbabilityCell = ({ rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<StagesFormValues>>();

  return (
    <Stack width="100%">
      <InterestInputField
        control={control}
        label="Win Probability"
        name={`bodyFields.${rowIndex}.winProbability`}
        textFieldProps={{ variant: 'outlined', required: true }}
      />
    </Stack>
  );
};
